import { css } from 'lit';
export default css `
  :host {
    --private-default-color: var(--amityeko-color-gray-1);
  }

  .dropdown::part(panel) {
    border-radius: 12px;
    box-shadow: var(--amityeko-elevation-6);
  }

  .menu::part(base) {
    padding: 4px;
    border: none;
    border-radius: var(--amityeko-radius-small);
  }

  .menu__item::part(base) {
    margin: 0;
    padding: 12px 8px;
    font-size: 16px;
    color: var(--private-color, var(--private-default-color));
    border-radius: var(--amityeko-radius-tiny);
    --amityeko-icon-color: var(--private-color, var(--private-default-color));
  }

  .menu__item:not(.menu__item--with-icon)::part(label) {
    margin-left: -24px; /* workaround for a hardcoded check sl-element */
  }

  .menu__item::part(prefix) {
    width: 20px;
    margin-left: -24px; /* workaround for a hardcoded check sl-element */
    margin-inline-end: 8px;
  }

  .menu__item::part(base):hover {
    background-color: var(--amityeko-color-gray-9);
  }
`;
//# sourceMappingURL=styles.js.map